import payload_plugin_qLmFnukI99 from "C:/git/niem/api/niem-toolbox/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "C:/git/niem/api/niem-toolbox/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "C:/git/niem/api/niem-toolbox/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "C:/git/niem/api/niem-toolbox/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "C:/git/niem/api/niem-toolbox/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "C:/git/niem/api/niem-toolbox/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "C:/git/niem/api/niem-toolbox/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "C:/git/niem/api/niem-toolbox/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "C:/git/niem/api/niem-toolbox/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "C:/git/niem/api/niem-toolbox/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "C:/git/niem/api/niem-toolbox/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import slideover_ZLoaDmlvnw from "C:/git/niem/api/niem-toolbox/node_modules/@nuxt/ui/dist/runtime/plugins/slideover.js";
import modal_X5eKYYwod7 from "C:/git/niem/api/niem-toolbox/node_modules/@nuxt/ui/dist/runtime/plugins/modal.js";
import colors_ETtiVmZNmO from "C:/git/niem/api/niem-toolbox/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "C:/git/niem/api/niem-toolbox/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "C:/git/niem/api/niem-toolbox/node_modules/@nuxt/icon/dist/runtime/plugin.js";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  slideover_ZLoaDmlvnw,
  modal_X5eKYYwod7,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh
]